import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import Header from "../DashboardProjetistaComponents/Header";

import { CardProfileSession } from "./CardProfileSession";

const cardsSessions = [
  {
    Icon: BusinessCenterOutlinedIcon,
    title: "Sua página",
    subTitle: "Edite aqui sua página",
    link: "/edit-pagina-projetista"
  },
  {
    Icon: PeopleAltOutlinedIcon,
    title: "Informações pessoais",
    subTitle: "Edite aqui o seu perfil",
    link: "/info-pessoais-projetista"
  },
  {
    Icon: HowToRegOutlinedIcon,
    title: "Entrar & Segurança",
    subTitle: "Edite aqui o seus dados de login",
    link: "/entrar-seguranca-projetista"
  },
  {
    Icon: Inventory2OutlinedIcon,
    title: "Serviços",
    subTitle: "Edite aqui seus serviços",
    link: "/"
  },
]


export function ProjetistaProfile() {
  return (
    <>
      <Header
        title={<span>Hey <strong>Projetista</strong>, edite seu cadastro aqui</span>}
      />
      < LinkSession >
        {
          cardsSessions.map((card, index) => (
            <CardProfileSession
              key={index}
              Icon={card.Icon}
              title={card.title}
              subTitle={card.subTitle}
              link={card.link}
            />
          ))
        }

      </LinkSession >

    </>
  )
}

const LinkSession = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  margin: 10px 0;
`